function VoucherPrinting(){
     return(
           <div>  
             <h2>VocherPrinting</h2>
             <p>details here</p>
            </div>
         );
}
export default VoucherPrinting;